/* Shopify remains the source of price, inventory, cart and checkout state. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root.document || root.__lanewildCommerceBound) return;
  root.__lanewildCommerceBound = true;
  var doc = root.document;

  function selectedState(section) {
    var select = section.querySelector('[data-variant-select]');
    var option = select && select.options[select.selectedIndex];
    return api.variantState(option ? Object.assign({ id: option.value }, option.dataset) : null, section.dataset.saleGate === 'true', section.dataset.previewPrices === 'true', section.dataset.catalogTest === 'true');
  }

  function showImage(section, url, alt) {
    var image = section.querySelector('[data-product-image]');
    if (!image || !url) return;
    image.removeAttribute('srcset');
    image.src = url;
    image.alt = alt || section.dataset.productTitle || '';
  }

  function matchingOption(section, color, config) {
    var options = Array.from(section.querySelectorAll('[data-variant-select] option'));
    return options.find(function (option) { return option.dataset.color === color && option.dataset.config === config; }) || options.find(function (option) { return option.dataset.color === color; });
  }

  function updateSection(section, updateUrl) {
    var state = selectedState(section);
    var price = section.querySelector('[data-variant-price]');
    var compare = section.querySelector('[data-variant-compare-price]');
    var button = section.querySelector('[data-add-to-cart]');
    var status = section.querySelector('[data-variant-status]');
    if (price) price.textContent = state.priceDisplay;
    if (compare) { compare.textContent = state.compareDisplay; compare.hidden = !state.compareDisplay; }
    if (button) { button.disabled = !state.canBuy; button.textContent = state.buttonText; }
    if (status) status.textContent = state.status;
    var priceLabel = section.querySelector('[data-price-label]');
    if (priceLabel) priceLabel.textContent = state.priceLabel || section.dataset.currency || '';
    var colorLabel = section.querySelector('[data-color-label]');
    if (colorLabel) colorLabel.textContent = state.color;
    var configSelect = section.querySelector('[data-config-select]');
    if (configSelect) configSelect.value = state.config;
    var configNote = section.querySelector('[data-config-copy]');
    if (configNote) configNote.textContent = state.configNote;
    section.querySelectorAll('[data-color-choice]').forEach(function (choice) {
      choice.setAttribute('aria-pressed', String(choice.dataset.colorChoice === state.color));
      var match = matchingOption(section, choice.dataset.colorChoice, state.config);
      if (match) choice.href = section.dataset.productUrl + '?variant=' + encodeURIComponent(match.value);
    });
    var image = section.querySelector('[data-product-image]');
    if (image) {
      showImage(section, state.image || image.dataset.defaultSrc, state.alt || image.dataset.defaultAlt);
      var side = section.querySelector('[data-gallery-side]');
      if (side) {
        side.dataset.galleryImage = image.getAttribute('src');
        side.dataset.imageAlt = image.alt;
        var thumbnail = side.querySelector('img');
        if (thumbnail) thumbnail.src = image.getAttribute('src');
      }
      section.querySelectorAll('[data-gallery-image]').forEach(function (thumb) { thumb.setAttribute('aria-pressed', String(thumb.hasAttribute('data-gallery-side'))); });
      var main = section.querySelector('.gallery-main');
      if (main) main.classList.remove('detail');
      var caption = section.querySelector('[data-gallery-caption]');
      if (caption) caption.textContent = section.dataset.imageLabel || 'Product imagery';
    }
    if (updateUrl && state.id) {
      try {
        var url = new URL(root.location.href);
        url.searchParams.set('variant', state.id);
        root.history.replaceState({}, '', url.toString());
      } catch (_) { /* Variant selection and native form still work without History API. */ }
    }
  }

  function initialize(scope) {
    var sections = Array.from(scope.querySelectorAll('[data-product-section]'));
    if (scope.matches && scope.matches('[data-product-section]')) sections.unshift(scope);
    sections.forEach(function (section) {
      updateSection(section, false);
      if (section.querySelector('[data-config-select]')) {
        section.querySelector('[data-enhanced-config]').hidden = false;
        var nativeSelect = section.querySelector('[data-native-variant]');
        if (nativeSelect) nativeSelect.hidden = true;
      }
      var dialog = section.querySelector('[data-fit-dialog]');
      if (dialog && typeof dialog.showModal === 'function') {
        var trigger = section.querySelector('[data-open-fit]');
        var fallback = section.querySelector('[data-fit-fallback]');
        if (trigger) trigger.hidden = false;
        if (fallback) fallback.hidden = true;
      }
    });
    scope.querySelectorAll('[data-cart-quantity]').forEach(function (button) { button.hidden = false; });
  }

  doc.addEventListener('change', function (event) {
    if (event.target.matches('[data-config-select]')) {
      var section = event.target.closest('[data-product-section]');
      var state = selectedState(section);
      var option = matchingOption(section, state.color, event.target.value);
      if (option) { section.querySelector('[data-variant-select]').value = option.value; updateSection(section, true); }
    } else if (event.target.matches('[data-variant-select]')) {
      updateSection(event.target.closest('[data-product-section]'), true);
    }
  });
  doc.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-product-form]')) return;
    var section = form.closest('[data-product-section]');
    if (!selectedState(section).canBuy) {
      event.preventDefault();
      updateSection(section, false);
      var status = section.querySelector('[data-variant-status]');
      if (status) status.focus();
    }
    /* Valid submissions use the native Shopify product form. No client cart or price payload. */
  });
  doc.addEventListener('click', function (event) {
    var target = event.target.closest('[data-gallery-image], [data-open-fit], [data-close-fit], [data-close-dialog], [data-open-zoom], [data-color-choice], [data-cart-quantity]');
    if (!target) return;
    if (target.hasAttribute('data-cart-quantity')) {
      var quantity = target.closest('.qty-control').querySelector('input');
      var next = Math.max(Number(quantity.min || 0), (parseInt(quantity.value, 10) || 0) + Number(target.dataset.cartQuantity));
      if (quantity.max) next = Math.min(Number(quantity.max), next);
      quantity.value = String(next);
      return;
    }
    var section = target.closest('[data-product-section]');
    if (!section) return;
    if (target.hasAttribute('data-gallery-image')) {
      showImage(section, target.dataset.galleryImage, target.dataset.imageAlt);
      section.querySelectorAll('[data-gallery-image]').forEach(function (thumb) { thumb.setAttribute('aria-pressed', String(thumb === target)); });
      section.querySelector('.gallery-main').classList.toggle('detail', target.dataset.galleryView === 'detail');
      var caption = section.querySelector('[data-gallery-caption]');
      if (caption) caption.textContent = target.dataset.galleryView === 'detail' ? 'Shared material concept' : section.dataset.imageLabel || 'Product imagery';
    } else if (target.hasAttribute('data-color-choice')) {
      var option = matchingOption(section, target.dataset.colorChoice, selectedState(section).config);
      if (option) { event.preventDefault(); section.querySelector('[data-variant-select]').value = option.value; updateSection(section, true); }
    } else if (target.hasAttribute('data-open-zoom')) {
      var zoom = section.querySelector('[data-zoom-dialog]');
      var current = section.querySelector('[data-product-image]');
      if (zoom && current && typeof zoom.showModal === 'function') {
        var enlarged = zoom.querySelector('img'); enlarged.src = current.src; enlarged.alt = current.alt;
        if (!zoom.open) zoom.showModal();
      }
    } else if (target.hasAttribute('data-open-fit')) {
      var dialog = section.querySelector('[data-fit-dialog]');
      if (dialog && !dialog.open) dialog.showModal();
    } else {
      target.closest('dialog').close();
    }
  });
  doc.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { initialize(doc); }, { once: true });
  else initialize(doc);
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  function variantState(data, saleGate, previewPrices, catalogTest) {
    data = data || {};
    var id = /^\d+$/.test(String(data.id || '')) ? String(data.id) : '';
    var price = Number(data.price);
    var priced = data.price !== '' && data.price !== undefined && Number.isSafeInteger(price) && price > 0;
    var available = data.available === 'true';
    var canBuy = saleGate === true && previewPrices !== true && catalogTest !== true && !!id && available && priced;
    var comparePrice = Number(data.comparePrice);
    return {
      id: id,
      canBuy: canBuy,
      priceDisplay: (saleGate === true || previewPrices === true) && priced ? String(data.priceDisplay || 'Price to be confirmed') : 'Price to be confirmed',
      priceLabel: previewPrices === true ? 'Preview price · not for sale' : '',
      compareDisplay: saleGate === true && priced && Number.isSafeInteger(comparePrice) && comparePrice > price ? String(data.compareDisplay || '') : '',
      image: String(data.image || ''),
      alt: String(data.alt || ''),
      color: String(data.color || ''), config: String(data.config || ''), configNote: String(data.configNote || ''),
      buttonText: catalogTest === true || previewPrices === true ? 'Preview only · not for sale' : saleGate !== true ? 'Preview only' : !priced ? 'Price to be confirmed' : !available || !id ? 'Unavailable' : 'Add to bag',
      status: catalogTest === true || previewPrices === true ? 'Concept configuration. Final specification and fit to be confirmed. Ordering is disabled.' : saleGate !== true ? 'Ordering is not available for this product in the selected market.' : !priced ? 'Final pricing is being confirmed.' : !available || !id ? 'This configuration is currently unavailable.' : 'Available to add to your bag. Delivery options appear at checkout.'
    };
  }
  return { variantState: variantState };
});
